
import { AUTH } from '../types/authTypes';

export const initializeAuth = () => {
	return (dispatch) => {
		try {
			const json = localStorage.getItem('auth');
			const data = JSON.parse(json);
			if (data) {
				dispatch(login(data));
			}
		} catch (e) {
		}
	};
};
export const login = (data) => (
	{
	type: AUTH.LOGIN,
	data
});

export const startLogout = () =>{
	localStorage.clear();
	return (dispatch) => {
		dispatch(logout())
	};
}

export const logout = () => ({
	type: AUTH.LOGOUT
});
